intra_module.controller('FeaturesCtrl', function($scope, features) {
  $scope.filebank_enabled = features.filebank_enabled;
  $scope.$watch('filebank_enabled', function() {
	features.setUserPref('filebank_enabled', $scope.filebank_enabled);
  });

  $scope.no_log_schedules_enabled = features.no_log_schedules_enabled;
  $scope.$watch('no_log_schedules_enabled', function() {
	features.setUserPref('no_log_schedules_enabled', $scope.no_log_schedules_enabled);
  });
});
